import { useQuery } from "@tanstack/react-query";
import type { ChecklistTemplate } from "@/types/components";

const apiUrl = import.meta.env.VITE_CLOUDFLARE_API_URL || "http://localhost:8788";

interface UsePricingConfiguratorDataProps {
  templateId?: number | null;
}

export function usePricingConfiguratorData({ templateId }: UsePricingConfiguratorDataProps) {
  // Fetch template with full component data
  const {
    data: templateData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["template-pricing", templateId],
    queryFn: async () => {
      if (!templateId) return null;
      const response = await fetch(`${apiUrl}/api/v1/templates/${templateId}`);
      if (!response.ok) throw new Error("Failed to fetch template");
      const result = await response.json();
      return result.data as ChecklistTemplate;
    },
    enabled: !!templateId,
  });

  return {
    templateData,
    isLoading,
    error,
  };
}
